import React, { useCallback, useContext, useEffect, useRef, useState } from 'react'
import { Button, FormControl, IconButton, makeStyles, MenuItem, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tooltip, withStyles } from '@material-ui/core';
import { db } from '../../../config/firebase';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import { Edit, PlayArrow, Stop } from '@material-ui/icons';
import { UserContext } from '../../../context/UserProvider';
import { Alert } from '@material-ui/lab';


const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: "#3B3C43",
    color: " #FFFFFF",
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

// Estilos para la tabla
const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    marginTop: theme.spacing(3),
  },
  table: {
    minWidth: 650,
  },
  tableContainer: {
    marginBottom: theme.spacing(2),
  },
  actionButton: {
    marginRight: theme.spacing(1),
  },
  detailsTable: {
    marginBottom: theme.spacing(2),
  },
}));

// Función para mapear acciones a números (igual que en WaterTankForm.jsx)
const getActionKind = (action) => {
  switch (action) {
    case "open":
      return 0;
    case "close":
      return 1;
    case "stop":
      return 2;
    default:
      return 1;
  }
};

function Row(props) {
  const { row, currentMac, username, handleEdit, handleExecute, isExecuting, canIdIrrigation, waitingForConfirmation } = props;
  const [open, setOpen] = useState(false);
  

  // Función para determinar la acción inicial basada en currentStatus
  const getInitialActionSelected = () => {
    // Si el tanque está ejecutándose, usar la acción actual del currentStatus
    if (row.status) {
      switch (row.status) {
        case "open":
          return 1; //Regresamos el opuesto de open
        case "close":
          return 0; //Regresamos el opuesto de close
        case "closed-interrupted":
          return 1; //Regresamos el valor de close
        case "open-interrupted":
            return 0; //Regresamos el valor de open
        default:
          return row.action === "open" ? 0 : 1;
      }
    }
    
  };

  const [actionSelected, setActionSelected] = useState(getInitialActionSelected());
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [tooltipText, setTooltipText] = useState("");

  const classes = useStyles();

  //FUncion para enviar el comando MQTT
  const handleExecuteRow = () => {
    handleExecute(row,actionSelected)
  }

  useEffect(() => {
    if (!isExecuting || !username || !currentMac) {
      return;
    }

    const docPath = `${username}/infoDevices/${currentMac}/${canIdIrrigation}/fromModule/configOK`;
    const docRef = db.doc(docPath);

    const unsubscribe = docRef.onSnapshot(snapshot => {
      const data = snapshot.data();

      if (data) {
        // Verificar los parámetros exactos que indican detención de operación:
        // accion=244: Código específico para operaciones de tanques
        // act="recOK": Confirmación de recepción del comando
        // kind=actionSelected: Tipo de acción (1=fill, 0=empty, 3=recirculate)
        // outid=row.id: ID del tanque específico
        // val=0: Valor 0 indica detención de la operación
        if (
          data.accion === 243 &&
          data.act === "recOK" &&
          data.kind === actionSelected &&
          data.outid === row.id &&
          data.val === 0
        ) {
          console.log(`Operación detenida por Firebase para ${row.name}. Acción: ${getActionKind(actionSelected)}`);

          // Crear la fecha de finalización
          const completionTime = new Date().toISOString();

          // Notificar al componente padre que la operación ha terminado por Firebase
          // Pasamos la fecha de finalización como parámetro adicional
          // Finalización confirmada por Firebase (no por switch)
          // handleExecute(row, true, false, completionTime, true);
        } else if(
          data.accion === 243 &&
          data.act === "recOK" &&
          data.kind === actionSelected &&
          data.outid === row.id &&
          data.val === 1
        ) {

        }
      }
    });
  }, [currentMac,row.id])
  

  const handleActionChange = (event, curtainId) => {
    const newAction = event.target.value === 1 ? "open" : "close";

    // El selector ya está deshabilitado cuando isExecuting es true,
    // pero agregamos esta verificación como medida de seguridad adicional
    if (!isExecuting && !waitingForConfirmation) {
      // Actualizar el estado local inmediatamente
      setActionSelected(event.target.value);

      // // Notificar al componente padre sobre el cambio de acción
      // handleEdit({ ...row, action: newAction });
    }
  };

  return (
    <React.Fragment>
      {/* Fila principal */}
      <TableRow>
        {/* <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell> */}
        <TableCell component="th" scope="row">
          {row.name}
        </TableCell>
        <TableCell>
          <FormControl className={classes.formControl}>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={actionSelected}
              onChange={(e) => handleActionChange(e, row.id)}
              disabled={isExecuting || waitingForConfirmation}
            >
              <MenuItem value={0}>Abrir</MenuItem>
              <MenuItem value={1}>Cerrar</MenuItem>

            </Select>
          </FormControl>
        </TableCell>
        
        <TableCell>
          <Tooltip title={tooltipText} placement="top" arrow>
            <span>
              <Button
                variant="contained"
                color={isExecuting ? "secondary" : "primary"}
                size="small"
                startIcon={isExecuting ? <Stop /> : <PlayArrow />}
                onClick={handleExecuteRow}
                data-tank-id={row.id}
                disabled={waitingForConfirmation || (buttonDisabled && !isExecuting)}
              >
                {isExecuting ? 'Detener' : 'Ejecutar'}
              </Button>
            </span>
          </Tooltip>
        </TableCell>
        <TableCell>
          <IconButton
            aria-label="editar"
            className={classes.actionButton}
            onClick={() => {
              // Pasamos el objeto row sin la propiedad action para diferenciar
              // entre cambio de acción y edición completa
              const { action, ...tankWithoutAction } = row;
              handleEdit(tankWithoutAction);
            }}
            disabled={isExecuting || waitingForConfirmation}
          >
            <Edit />
          </IconButton>
          
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

export const ManualCurtainControl = ({curtainsData, username, currentMac, canIdIrrigation}) => {
  const classes = useStyles();
  const [waitingForConfirmation, setWaitingForConfirmation] = useState(false)
  const [mqttValidationAlert, setMqttValidationAlert] = useState({ show: false, type: 'info', message: '' });
  const [executingCurtains, setExecutingCurtains] = useState(new Set()); // Estado para rastrear cortinas en ejecución
  const retryCountRef = useRef(0);
  const timeoutRef    = useRef(null);
  const currentCmdRef = useRef(null);
  const unsubscribeRef = useRef(null);

  const handleEdit = (tank) => {
    console.log("Se edita la cortina", tank)
  }

  const handleSuccessfulMqttValidation = async (commandData) => {
    // Verificar que commandData existe y tiene las propiedades necesarias
    if (!commandData || typeof commandData !== 'object') {
      console.error("commandData es null, undefined o no es un objeto válido en handleSuccessfulMqttValidation:", commandData);
      return;
    }

    const { curtainId, isExecuting } = commandData;
    console.log("Esto es commandData:",commandData)

    // Verificar que curtainId existe
    if (curtainId === undefined || curtainId === null) {
      console.error("curtainId es undefined o null en commandData:", commandData);
      return;
    }

    // Encontrar la cortina correspondiente
    const curtain = curtainsData.find(c => c.id === curtainId);
    if (!curtain) {
      console.error("No se encontró el tanque con ID:", curtainId);
      return;
    }

    // Actualizar el estado de ejecución cuando se confirma el comando MQTT
    // Si isExecuting es false, significa que estamos iniciando la operación (cambiar a ejecutando)
    // Si isExecuting es true, significa que estamos deteniendo la operación (cambiar a no ejecutando)
    setExecutingCurtains(prev => {
      const newSet = new Set(prev);
      if (!isExecuting) {
        // Iniciando operación: agregar al Set
        newSet.add(curtainId);
        console.log(`Cortina ${curtainId} marcada como ejecutándose`);
        
        // Emitir evento para que el monitor comience a monitorear esta cortina
        const event = new CustomEvent('curtainOperationStart', {
          detail: {
            curtainId: curtainId,
            action: commandData.action, // 0 = Abrir, 1 = Cerrar
            curtain: curtain
          }
        });
        window.dispatchEvent(event);
      } else {
        // Deteniendo operación: remover del Set
        newSet.delete(curtainId);
        console.log(`Cortina ${curtainId} marcada como detenida`);
      }
      return newSet;
    });

  };

  // Función para limpiar timeout y listener
  const clearConfirmationTimeout = () => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }
    if (unsubscribeRef.current) {
      unsubscribeRef.current();
      unsubscribeRef.current = null;
    }
  };
  
  const subscribeToConfirmation = (commandData) => {
    const addr = `${username}/infoDevices/${currentMac}/${canIdIrrigation}/fromModule`;
    const docRef = db.collection(addr).doc("configOK");

    // Cancelar cualquier suscripción previa
    if (unsubscribeRef.current) {
      unsubscribeRef.current();
    }

    unsubscribeRef.current = docRef.onSnapshot(snapshot => {
      const data = snapshot.data();
      console.log("Esto es commandData:", commandData);

      // Usar commandData del parámetro o como respaldo currentCmdRef.current
      let activeCommandData = commandData;

      // Si commandData es null/undefined, intentar usar currentCmdRef.current como respaldo
      if (!activeCommandData || typeof activeCommandData !== 'object') {
        console.warn("commandData es null, undefined o no es un objeto válido, intentando usar currentCmdRef.current como respaldo");
        activeCommandData = currentCmdRef.current;
      }

      // Verificar que tenemos datos válidos para proceder
      if (!activeCommandData || typeof activeCommandData !== 'object') {
        console.warn("No hay datos de comando válidos disponibles, cancelando validación");
        return;
      }

      // Verificar que activeCommandData tiene las propiedades requeridas
      if (activeCommandData.action === undefined || activeCommandData.expectedVal === undefined || activeCommandData.curtainId === undefined) {
        console.warn("Los datos de comando no tienen las propiedades requeridas:", activeCommandData);
        return;
      }

      // Aquí la comparación exacta que tú indicas:
      if (
        data &&
        data.accion === 243 &&
        data.act === 'recOK' &&
        data.kind === activeCommandData.action &&
        data.val === activeCommandData.expectedVal &&
        data.outid === activeCommandData.curtainId
      ) {
        console.log("Entre a operacion exactamente")
        // Confirmación recibida correctamente
        clearConfirmationTimeout();

        setWaitingForConfirmation(false);
        setMqttValidationAlert({
          show: true,
          type: 'success',
          message: '✅ El módulo confirmó el comando.'
        });

        // AQUÍ ES DONDE AHORA CAMBIAMOS EL ESTADO DEL BOTÓN Y MOSTRAMOS ALERTAS
        handleSuccessfulMqttValidation(activeCommandData);
        setTimeout(setMqttValidationAlert, 4000, { show: false, type: '', message: '' });

        currentCmdRef.current = null;
      }
      // Nota: La detección de término de rutina (val === 0) y acción no ejecutable (val === 3)
      // ahora se maneja en CurtainMonitor.jsx para funcionar independientemente
    });
  };

  //Envio de datos por MQTT
  const sendingManualCurtains = async (e, n) => {
    const item = {
        msMqtt: e,
        mac: currentMac,
        action: "Manual Curtains",
        fecha: Date.now(),
        uid: n
    }

    try {
      setWaitingForConfirmation(true)
      const addr = `${username}/infoDevices/${currentMac}/${canIdIrrigation}/sendConfigModule`
      await db.collection(addr).doc("sendConfig").set({ item })
      //console.log("Esto es macId:", macId)
    } catch (error) {
        console.log(error)
    }
  };

  const sendCommand = async(mqtt,moduleId,row,isExecuting,actionRow) => {
    const commandData = {
      action: actionRow,
      expectedVal: isExecuting ? 0 : 1,
      curtainId: row.id,
      mqtt,
      moduleId,
      isExecuting // Agregar esta información para saber si estamos iniciando o deteniendo
    };

    currentCmdRef.current = commandData;
    retryCountRef.current = 0;

    setWaitingForConfirmation(true);
    setMqttValidationAlert({
      show: true,
      type: 'info',
      message: '⏳ Esperando respuesta del módulo ambiente...'
    });

    // 4.1 Publicar el comando MQTT
    await sendingManualCurtains(mqtt, moduleId);

    // 4.2 Suscribirse al documento de Firebase
    subscribeToConfirmation(commandData);

    // 4.3 Programar el timeout del primer intento
    timeoutRef.current = setTimeout(handleMqttTimeout, 5000);
  }


  const handleMqttTimeout = async () => {
    // Verificar que currentCmdRef.current existe antes de proceder
    if (!currentCmdRef.current) {
      console.warn("currentCmdRef.current es null en handleMqttTimeout, cancelando reintentos");
      clearConfirmationTimeout();
      setWaitingForConfirmation(false);
      return;
    }

    if (retryCountRef.current < 2) {
      retryCountRef.current += 1;
      setMqttValidationAlert({
        show: true,
        type: 'warning',
        message: `🔄 Reintentando envío de comando... (Intento ${retryCountRef.current + 1}/3)`
      });

      const { mqtt, moduleId } = currentCmdRef.current;

      // Verificar que los datos necesarios existen
      if (!mqtt || !moduleId) {
        console.error("Datos de comando incompletos para reintento:", currentCmdRef.current);
        clearConfirmationTimeout();
        setWaitingForConfirmation(false);
        setMqttValidationAlert({
          show: true,
          type: 'error',
          message: '❌ Error en los datos del comando. Operación cancelada.'
        });
        setTimeout(setMqttValidationAlert, 4000, { show: false, type: '', message: '' });
        currentCmdRef.current = null;
        return;
      }

      // Reenviar comando
      await sendingManualCurtains(mqtt, moduleId);

      // Limpiar timeout y listener anterior
      clearConfirmationTimeout();

      // Volver a suscribir listener con la misma lógica
      subscribeToConfirmation(currentCmdRef.current);

      // Programar siguiente timeout
      timeoutRef.current = setTimeout(handleMqttTimeout, 5000);

    } else {
      // Tras 3 intentos, confirmar fallo
      clearConfirmationTimeout();
      setWaitingForConfirmation(false);
      setMqttValidationAlert({
        show: true,
        type: 'error',
        message: '❌ No responde el módulo ambiente. Verifique la conexión.'
      });
      setTimeout(setMqttValidationAlert, 4000, { show: false, type: '', message: '' });
      currentCmdRef.current = null;
    }
  };

  //FUncion para enviar el comando MQTT
  const handleExecute = async(row,actionRow) => {
    // Verificar si la cortina ya está ejecutándose
    const isCurrentlyExecuting = executingCurtains.has(row.id);
    
    let mqtt = "";
    const len = 3;
    const action = 243;
    const canID = canIdIrrigation;
    // Si está ejecutándose, usar acción de detener (2), sino usar la acción seleccionada (0 o 1)
    const typeAction = isCurrentlyExecuting ? 2 : actionRow;
    const rowIndex = row.id;

    const moduleId = currentMac + "@" + canIdIrrigation;

    mqtt =
        len +
        "," +
        action +
        "," +
        canID +
        "," +
        rowIndex +
        "," +
        typeAction;

    // Pasar isCurrentlyExecuting para indicar si estamos iniciando o deteniendo
    // Para detener, pasamos actionRow = 2 (stop)
    const actionForCommand = isCurrentlyExecuting ? 2 : actionRow;
    sendCommand(mqtt,moduleId,row,isCurrentlyExecuting,actionForCommand)
    // sendingManualCurtains(mqtt,moduleId)
    console.log("Se envia el siguiente comando MQTT:",mqtt)
    console.log("Estado de ejecución:", isCurrentlyExecuting ? "Deteniendo" : "Iniciando")
  }

  // Listener para eventos de finalización de operación desde CurtainMonitor
  useEffect(() => {
    const handleCurtainOperationComplete = (event) => {
      const { curtainId, completionReason } = event.detail;
      
      console.log(`[ManualCurtainControl] Operación completada para cortina ${curtainId}, razón: ${completionReason}`);
      
      // Remover la cortina del conjunto de ejecución para actualizar el botón
      setExecutingCurtains(prev => {
        const newSet = new Set(prev);
        newSet.delete(curtainId);
        return newSet;
      });
    };

    window.addEventListener('curtainOperationComplete', handleCurtainOperationComplete);

    return () => {
      window.removeEventListener('curtainOperationComplete', handleCurtainOperationComplete);
    };
  }, []);

  return (
    <React.Fragment>
      <TableContainer component={Paper} className={classes.tableContainer}>
        <Table className={classes.table} aria-label="collapsible table">
          <TableHead>
            <TableRow>
              {/* <StyledTableCell /> */}
              <StyledTableCell align="left">Cortina</StyledTableCell>
              <StyledTableCell align="left">Acción</StyledTableCell>
              <StyledTableCell align="left">Ejecutar</StyledTableCell>
              <StyledTableCell align="left">Editar Nombre</StyledTableCell>
              {/* <TableCell>Acción</TableCell>
              <TableCell>Última ejecución</TableCell>
              <TableCell>Ejecutar</TableCell>
              <TableCell>Editar/Eliminar</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {curtainsData && curtainsData.map((curtain) => {
              // Determinar si el tanque está ejecutándose basándose en currentStatus y estado local
              const isCurrentlyExecuting = () => {
                // Verificar primero el estado local de ejecución
                if (executingCurtains.has(curtain.id)) {
                  return true;
                }
                // Si currentStatus indica que está ejecutándose, usar esa información
                if (curtain.isExecutingM) {
                  return true;
                }
                return false;
              };

              return (
                <Row
                  key={curtain.id}
                  row={curtain}
                  currentMac={currentMac}
                  username={username}
                  handleEdit={handleEdit}
                  handleExecute={handleExecute}
                  isExecuting={isCurrentlyExecuting()}
                  canIdIrrigation={canIdIrrigation}
                  waitingForConfirmation={waitingForConfirmation}
                />
              );
            })}
            {(!curtainsData || curtainsData.length === 0) && (
              <TableRow>
                <TableCell colSpan={6} align="center">
                  No hay cortinas configuradas
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Alerta de operación completada - ahora fuera del TableBody */}
      {/* Alert para validación MQTT */}
      {mqttValidationAlert.show && (
        // <div style={{ position: 'fixed', top: '20px', right: '20px', zIndex: 9999 }}>
        <div>
          <Alert
            severity={mqttValidationAlert.type}
            onClose={() => setMqttValidationAlert({ show: false, type: '', message: '' })}
          >
            {mqttValidationAlert.message}
          </Alert>
        </div>
      )}
      
    </React.Fragment>
  )
}
